/* import __COLOCATED_TEMPLATE__ from './handoff-to-support.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    sdrEscalationMode?: string | null;
  };
}

export default class HandoffToSupport extends Component<Signature> {
  get isHandoverEnabled() {
    return this.args.sdrEscalationMode === 'handover_to_service_agent';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::HandoffToSupport': typeof HandoffToSupport;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/handoff-to-support': typeof HandoffToSupport;
  }
}
